<ng-container *vsLet="page$ | async as page">
  <ng-container *ngIf="!initialLoading; else loadingSkeleton">
    <div *ngIf="loadError" class="p-6" role="alert">
      <p class="text-danger mb-4">Unable to load payments. Please try again.</p>
      <button vs-button appearance="outline" (click)="refresh()">Try again</button>
    </div>
    <ng-container *ngIf="!loadError">
      <ng-container *ngIf="salesCount; else noSales">
        <vs-table
          *ngIf="columns$ | async as columns"
          [columns]="columns"
          [data]="page?.items ?? []"
          (rowClicked)="rowClicked.emit($event)"
          (sortChanged)="onSortChanged($event)"
        ></vs-table>

        <vs-pagination
          [config]="page?.meta"
          (pagination)="pagination$.next({ page: $event.currentPage, limit: $event.itemsPerPage })"
        ></vs-pagination>
      </ng-container>

      <ng-template #noSales>
        <vs-empty-state
          class="p-8 -mt-3"
          [config]="{
            title: 'No sales found.',
            subtitle: 'Once a sale has been made, its details will appear here!',
            imgsrc: 'distributor',
          }"
        ></vs-empty-state>
      </ng-template>
    </ng-container>
  </ng-container>

  <ng-template #loadingSkeleton>
    <ng-container *ngIf="columns$ | async as columns">
      <vs-table-skeleton [rows]="10" [columns]="columns.length"></vs-table-skeleton>
    </ng-container>
  </ng-template>
</ng-container>
